import styled, { css } from 'styled-components';
import {
  popeyesNeutral,
  spacings,
  breakpoints,
  ZIndex,
  popeyesSecondaryColors,
  font,
} from 'styles';

import * as T from './interfaces';

export const ItemHeader = styled.li<T.IItemHeader>`
  transition: all 1s;
  ${({ mapMode, isMobileDevice }) => css`
    ${mapMode && !isMobileDevice ? 'width: 50%;' : 'width: 100%;'}
  `}
`;

export const WrapperUniqChild = styled.li`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`;

const MediaModifier = {
  desktop: () => css`
    padding: 275px 0px 10px 0px;
  `,
  mobile: () => css`
    padding-top: 215px;
  `,
};

const WrapperModifier = {
  noScroll: () => css`
    overflow: visible;

    li {
      margin-top: 0 !important;
      border: none !important;
    }
  `,
  mapMode: (show: boolean) => css`
    @media (min-width: ${breakpoints.intermediary}) {
      > li:first-child {
        max-width: ${show ? 'calc(50vw - 10px)' : 'calc(100vw - 15px)'};
      }
    }
  `,

  showHeader: (show: boolean) => css`
    > li:first-child {
      position: ${show ? 'absolute' : 'fixed'};
      top: ${show ? '70px' : '0'};
      z-index: ${ZIndex.overhang};
      @media (max-width: ${breakpoints.intermediary}) {
        top: 0;
      }
    }
  `,
  modeSuggestion: (isTrue: boolean) => css`
    > li {
      + li {
        margin-top: ${isTrue ? 'none' : spacings.space05};
        :last-child {
          padding-bottom: ${isTrue ? 'none' : spacings.space07};
        }
      }
    }
  `,
};

export const SearchList = styled.ol<T.ISearchContainerStyles>`
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  height: min-content;

  > li {
    + li {
      border-top: 2px solid ${popeyesNeutral.neutral01};

      ${({ mapMode }) => (mapMode ? 'width: 90%;' : 'width: 60%;')}

      @media (max-width: ${breakpoints.intermediary}) {
        width: 90%;
      }
      transition: width 1s;
      justify-content: center;
    }
    :nth-child(2) {
      border-top: none;
    }
    :last-child {
      border-bottom: 2px solid ${popeyesNeutral.neutral01};
    }
  }
  overflow-y: auto;

  &::-webkit-scrollbar,
  &::-webkit-scrollbar-thumb {
    display: none;
  }
  scroll-behavior: smooth;

  @media (min-width: ${breakpoints.intermediary}) {
    ${MediaModifier.desktop()}
  }

  @media (max-width: ${breakpoints.intermediary}) {
    ${MediaModifier.mobile()}
  }
  ${({ showHeader, haveSuggestionPlaces, mapMode, noScroll }) => css`
    ${WrapperModifier.mapMode(mapMode)}
    ${WrapperModifier.showHeader(showHeader)}
    ${WrapperModifier.modeSuggestion(haveSuggestionPlaces)}
    ${noScroll && WrapperModifier.noScroll()}
  `}
`;

export const SearchWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
`;

export const SelectedWrapper = styled.ol`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  li {
    ul {
      margin: none;
    }
  }
`;

export const ChildBannerPosition = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  img {
    transform: translateX(-150%);
    height: 20px;
  }

  span {
    color: ${popeyesSecondaryColors.light};
    font-size: 14px;
    z-index: 1;
  }
`;
